import { AddRounded } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";

const AddNewTenantButton = ({
  onClick,
  labelVariant = "caption",
  labelColor = null,
  disabled = false,
  ...props
}) => {
  const colors = useColors();
  const defaultLabelColor = colors.text_secondary;

  return (
    <Button
      fullWidth
      disabled={disabled}
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        color: colors.text_primary,
        textTransform: "none",
        gap: "8px",
        borderRadius: "8px",
        padding: "4px",
        "&.Mui-disabled": {
          color: colors.text_disabled,
        },
        ...props.sx,
      }}
      onClick={onClick}
    >
      <AddRounded
        sx={{
          ml: "4px",
          width: "16px",
          color: disabled
            ? colors.text_disabled
            : colors.button_outlined_inherit_enabled_icon,
        }}
      />
      <Typography
        variant={labelVariant}
        sx={{
          color: disabled
            ? colors.text_disabled
            : labelColor || defaultLabelColor,
        }}
      >
        Add a new tenant
      </Typography>
    </Button>
  );
};

export default AddNewTenantButton;
